import { render, staticRenderFns } from "./invigilatorDashboard.vue?vue&type=template&id=956df676&"
import script from "./invigilatorDashboard.vue?vue&type=script&lang=js&"
export * from "./invigilatorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports